import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button, Badge } from 'reactstrap';
import {
  callApi,
  formatAmount,
  formatDateTime,
  formatSignedAmount,
} from '../../utils';
import Loading from '../Loading';
import UpdateUserWallet from '../UpdateUserWallet';
import UserOverdraft from './UserOverdraft';
import { openUpdateUserWalletModal } from '../../actions/modalActions';
import DataTable from '../DataTable';

class UserWallet extends React.Component {
  // Bumped after a wallet write. A credit or debit moves the balance, which in
  // turn moves the overdraft figures (the debt IS the negative balance), so the
  // overdraft panel and the transaction list re-read together.
  state = { refreshToken: 0 };

  refresh = () => {
    this.setState((state) => ({ refreshToken: state.refreshToken + 1 }));
  };

  updateWallet = () => {
    this.props.dispatch(
      openUpdateUserWalletModal({
        id: this.props.user.id,
        onSuccess: this.refresh,
      })
    );
  };

  render() {
    const { id, userWallet } = this.props.user;
    const { refreshToken } = this.state;

    return (
      <React.Fragment>
        <UpdateUserWallet />
        <Row>
          <Col md={6} xs={12}>
            <div className="d-flex align-items-center">
              {/* The balance used to sit here, but the card below now carries it
                  alongside the overdraft figures it depends on. Identify the
                  wallet instead. */}
              <h5 className="m-0 text-muted">
                {userWallet && userWallet.id ? (
                  `Wallet #${userWallet.id}`
                ) : (
                  <span>No wallet</span>
                )}
              </h5>
            </div>
          </Col>
          <Col md={6} xs={12}>
            <div className="d-flex justify-content-end align-items-center">
              <Button
                size="sm"
                color="primary"
                className="btn-sm-block"
                onClick={this.updateWallet}
              >
                Update Wallet
              </Button>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12} xs={12}>
            <UserOverdraft user={this.props.user} refreshToken={refreshToken} />
          </Col>
        </Row>
        <Row>
          <Col md={12} xs={12}>
            <Transactions id={id} refreshToken={refreshToken} />
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

function Transactions(props) {
  const { id, refreshToken } = props;
  const [page, setPage] = useState(1);
  const [transactions, setTransactions] = useState([]);
  const [checkpoint, setCheckpoint] = useState(null);
  const [loading, setLoading] = useState(false);

  // A wallet write prepends a new transaction, so drop back to page one rather
  // than refetching whichever page the operator had loaded more of.
  useEffect(() => {
    setLoading(true);
    setPage(1);

    callApi(`/users/${id}/wallet/transactions?page=1`)
      .then((res) => res.data)
      .then((data) => {
        setTransactions(data);
        const thisCheckpoint = data.length > 0 ? data[0].created_at : null;
        if (typeof setCheckpoint === 'function') {
          setCheckpoint(thisCheckpoint);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id, refreshToken]);

  function loadMore() {
    if (loading) {
      return;
    }

    setLoading(true);
    callApi(
      `/users/${id}/wallet/transactions?page=${
        page + 1
      }&checkpoint=${checkpoint}`
    )
      .then((res) => res.data)
      .then((data) => {
        setPage(page + 1);
        setTransactions([...transactions, ...data]);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <React.Fragment>
      <DataTable card={false} loading={loading} minWidth={800}>
        <thead className="text-primary">
          <tr>
            <th>#</th>
            <th>Date</th>
            <th>Reference</th>
            <th>Amount</th>
            <th>Balance Before</th>
            <th>Balance After</th>
            <th>Type</th>
          </tr>
        </thead>

        <tbody>
          {transactions.map((t, i) => {
            return (
              <tr
                // onClick={() => this.openTransaction(t.order_id)}
                key={t.order_id}
              >
                <td>{i + 1}</td>
                <td>{formatDateTime(t.created_at)}</td>
                <td>{t.ref}</td>
                <td
                  className={
                    t.operation === 'credit' ? 'text-success' : 'text-danger'
                  }
                >
                  <span className="font-weight-bold">
                    {formatAmount(t.amount)}
                  </span>
                </td>
                {/* Running balances can be negative while the customer is
                    drawing on their overdraft. */}
                <td
                  className={Number(t.balance_before) < 0 ? 'text-danger' : ''}
                >
                  {formatSignedAmount(t.balance_before)}
                </td>
                <td
                  className={Number(t.balance_after) < 0 ? 'text-danger' : ''}
                >
                  {formatSignedAmount(t.balance_after)}
                </td>
                <td>
                  <Badge>{t.type}</Badge>
                </td>
              </tr>
            );
          })}
        </tbody>
      </DataTable>
      <div className="text-center">
        {loading ? <Loading /> : <Button onClick={loadMore}>Load More</Button>}
      </div>
    </React.Fragment>
  );
}

export default connect()(UserWallet);
